// eslint-disable-next-line @nx/enforce-module-boundaries
import { Spreadsheet, Worksheet } from '@mode/dataset/excel/contract';

export interface SpreadsheetDto {
  id: string;
  name: string;
  owner: string;
  last_opened?: string;
}

export interface WorksheetDto {
  id: string;
  name: string;
}

export interface SpreadsheetApiResponse {
  _embedded: Readonly<{ spreadsheets: readonly SpreadsheetDto[] }>;
  _links?: Readonly<{
    next_page?: Readonly<{ href: string }>;
  }>;
}

export function mapDtoToSpreadsheet({ id, name, owner, last_opened }: SpreadsheetDto): Readonly<Spreadsheet> {
  return {
    id,
    name,
    owner,
    lastOpened: last_opened ? new Date(last_opened) : undefined,
  };
}

export function mapDtoToWorksheet({ id, name }: WorksheetDto): Readonly<Worksheet> {
  return {
    id,
    name,
  };
}
